import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = { role: ROLE.SUPER_ADMIN };

const path = "admin/report-booking"

export const List = async (values) => {
    return await axiosInstance(options).post(`${path}/list`, values);
}

export const UploadReport = async (values) => {
    return await axiosInstance(options).post(`${path}/upload-report`, values);
}

export const UpdateStatus = async (values) => {
    return await axiosInstance(options).post(`${path}/update-status`, values);
}

export const GetDownloadLogs = async (values) => {
    return await axiosInstance(options).post(`${path}/download-logs`, values);
}

export const RefundReportBooking = async (values) => {
    return await axiosInstance(options).post(`${path}/refund`, values);
}

